export default __webpack_public_path__ + "static/media/yellow.c61f7591.svg";